import { video } from "../interfaces";

const data: video[] = [
	// ============================================================================
	{
		id: "video1-2",
		name: "Saml din beskeder, mor",
		vimeoId: 441259313,
		inMenu: true,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video2-1",
			choices: [
				{
					disabled: false,
					desc: 'Afspil playlist "Bounty Bangers"',
					gotoId: "video2-1",
				},
				{
					disabled: false,
					desc: 'Afspil playlist "Back to the future"',
					gotoId: "video2-2",
				},
			],
		},
		notifications: [
			{
				timecode: 8,
				from: "Mor",
				platform: "messages",
				desc: "Kan du lige tømme opvaskemaskinen?",
				duration: 4,
			},
			{
				timecode: 14,
				from: "Mor",
				platform: "messages",
				desc: "😊😊😊😊😊",
				duration: 2,
			},
			{
				timecode: 24,
				from: "EVERYDAY UNIFORM",
				platform: "mail",
				desc: "Anmeld dit køb og vind tøj for 5000 kr ✅",
				duration: 4,
			},
			{
				timecode: 30,
				from: "Audify",
				platform: "audify",
				desc: "Speaker 'BOOMBOX250' connected",
				duration: 5,
			},
		],
	},
	// ============================================================================
	{
		id: "video2-1",
		name: "Valg af musik",
		vimeoId: 441259424,
		inMenu: false,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video3-1",
			choices: [
				{
					disabled: false,
					desc: "Åbn din pakke fra Everyday Uniform",
					gotoId: "video3-2",
				},
				{
					disabled: false,
					desc: "Se Garbage Island",
					gotoId: "video3-1",
				},
			],
		},
		notifications: [
			{
				timecode: 8.466,
				platform: "messages",
				duration: 5,
				from: "Valdemar",
				desc: "Fuck jeg elsker Garbage Island!	",
			},
		],
	},
	// =========================
	{
		id: "video2-2",
		name: "Valg af musik",
		vimeoId: 441259400,
		inMenu: false,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video3-1",
			choices: [
				{
					disabled: false,
					desc: "Åbn din pakke fra Everyday Uniform",
					gotoId: "video3-2",
				},
				{
					disabled: false,
					desc: "Se Garbage Island",
					gotoId: "video3-1",
				},
			],
		},
		notifications: [
			{
				timecode: 8.466,
				platform: "messages",
				duration: 5,
				from: "Valdemar",
				desc: "Fuck jeg elsker Garbage Island!	",
			},
		],
	},
	// ============================================================================
	{
		id: "video3-1",
		name: "Garbage Island & Essay",
		vimeoId: 459276948,
		inMenu: true,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video4-2",
			choices: [
				{
					disabled: false,
					desc: "Smid sedlen ud",
					gotoId: "video4-1",
				},
				{
					disabled: false,
					desc: "Søg på nummeret",
					gotoId: "video4-2",
				},
			],
		},
		notifications: [
			{
				timecode: 47.372,
				platform: "calendar",
				duration: 7,
				from: "FN essay deadline",
				desc: "2 timer til aflevering",
			},
		],
	},
	// =========================
	{
		id: "video3-2",
		name: "Åbn din pakke",
		vimeoId: 459277529,
		inMenu: true,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video4-2",
			choices: [
				{
					disabled: false,
					desc: "Smid sedlen ud",
					gotoId: "video4-1",
				},
				{
					disabled: false,
					desc: "Søg på nummeret",
					gotoId: "video4-2",
				},
			],
		},
		notifications: [],
	},
	// ============================================================================
	{
		id: "video4-1",
		name: "Smid sedlen ud",
		vimeoId: 441259464,
		inMenu: true,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video4-3",
			choices: [
				{
					disabled: true,
					desc: "Smid sedlen ud",
					gotoId: "video4-1",
				},
				{
					disabled: false,
					desc: "Saml sedlen op",
					gotoId: "video4-3",
				},
			],
		},
		notifications: [],
	},
	// =========================
	{
		id: "video4-3",
		name: "Saml sedlen op",
		vimeoId: 456152523,
		inMenu: true,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video5-1",
			choices: [
				{
					disabled: false,
					desc: "Snooze",
					gotoId: "video5-1",
				},
				{
					disabled: false,
					desc: "Stå op",
					gotoId: "video5-2",
				},
			],
		},
		notifications: [],
	},
	// =========================
	{
		id: "video4-2",
		name: "Søg på nummeret",
		vimeoId: 441259450,
		inMenu: true,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video5-2",
			choices: [
				{
					disabled: false,
					desc: "Snooze",
					gotoId: "video5-1",
				},
				{
					disabled: false,
					desc: "Stå op",
					gotoId: "video5-2",
				},
			],
		},
		notifications: [
			{
				timecode: 36,
				platform: "mail",
				duration: 5,
				from: "EVERYDAY UNIFORM",
				desc: "VIP-SALE starter midnat kl. 00:00 🕒🕒🕒",
			},
		],
	},
	// ============================================================================
	{
		id: "video5-1",
		name: "Snooze",
		vimeoId: 441259510,
		inMenu: false,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 5,
			defaultChoice: "video5-2",
			choices: [
				{
					disabled: true,
					desc: "Snooze",
					gotoId: "video5-1",
				},
				{
					disabled: false,
					desc: "Stå op",
					gotoId: "video5-2",
				},
			],
		},
		notifications: [],
	},
	// =========================
	{
		id: "video5-2",
		name: "Stå op",
		vimeoId: 441259529,
		inMenu: false,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video6-1",
			choices: [
				{
					disabled: false,
					desc: "Åbn kort og se placering",
					gotoId: "video6-1",
				},
				{
					disabled: false,
					desc: "Scroll videre",
					gotoId: "video6-2",
				},
			],
		},
		notifications: [
			{
				timecode: 84,
				platform: "mail",
				duration: 4,
				from: "EVERYDAY UNIFORM",
				desc: "Ophøj din stil! 😎 Ny 'SUMMER VIBES' kollektion",
			},
		],
	},
	// ============================================================================
	{
		id: "video6-1",
		name: "Annes fest",
		vimeoId: 472119395,
		inMenu: false,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 15,
			defaultChoice: "video7-1",
			choices: [
				{
					disabled: false,
					desc: "Post opslaget på Photobook",
					gotoId: "video7-1",
				},
				{
					disabled: false,
					desc: "Slet opslaget",
					gotoId: "video7-2",
				},
			],
		},
		notifications: [],
	},
	// =========================
	{
		id: "video6-2",
		name: "Annes fest",
		vimeoId: 472119741,
		inMenu: true,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 15,
			defaultChoice: "video7-2",
			choices: [
				{
					disabled: false,
					desc: "Post opslaget på Photobook",
					gotoId: "video7-1",
				},
				{
					disabled: false,
					desc: "Slet opslaget",
					gotoId: "video7-2",
				},
			],
		},
		notifications: [],
	},
	// ============================================================================
	{
		id: "video7-1",
		name: "Post opslaget",
		vimeoId: 472119433,
		inMenu: true,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video8-2",
			choices: [
				{
					disabled: false,
					desc: "Kald det for en aften og tag hjem",
					gotoId: "video8-1",
				},
				{
					disabled: false,
					desc: "Bliv til en øl mere",
					gotoId: "video8-2",
				},
			],
		},
		notifications: [],
	},
	// =========================
	{
		id: "video7-2",
		name: "Slet opslaget",
		vimeoId: 472311871,
		inMenu: true,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 7,
			defaultChoice: "video7-1",
			choices: [
				{
					disabled: false,
					desc: "Post opslaget på Photobook",
					gotoId: "video7-1",
				},
				{
					disabled: true,
					desc: "Slet opslaget",
					gotoId: "video7-2",
				},
			],
		},
		notifications: [],
	},
	// ============================================================================
	{
		id: "video8-1",
		name: "Tag hjem",
		vimeoId: 472119538,
		inMenu: false,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video10-1",
			choices: [
				{
					disabled: false,
					desc: "Tjek Quicksnap fra Josefine",
					gotoId: "video10-1",
				},
				{
					disabled: false,
					desc: "Ignorér",
					gotoId: "video10-2",
				},
			],
		},
		notifications: [],
	},
	// =========================
	{
		id: "video8-2",
		name: "En.. Øl.. Mere!",
		vimeoId: 472119542,
		inMenu: false,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video10-2",
			choices: [
				{
					disabled: false,
					desc: "Tjek Quicksnap fra Josefine",
					gotoId: "video10-1",
				},
				{
					disabled: false,
					desc: "Ignorér",
					gotoId: "video10-2",
				},
			],
		},
		notifications: [],
	},
	// ============================================================================
	{
		id: "video10-1",
		name: "Se quicksnap",
		vimeoId: 472119584,
		inMenu: false,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video11-2",
			choices: [
				{
					disabled: false,
					desc: "Spørg Ayaan om timeløn",
					gotoId: "video11-1",
				},
				{
					disabled: false,
					desc: "Spørg Ayaan om hvor mange der arbejder på fabrikken",
					gotoId: "video11-2",
				},
			],
		},
		notifications: [],
	},
	// =========================
	{
		id: "video10-2",
		name: "Ignorér besked",
		vimeoId: 472119586,
		inMenu: false,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video11-1",
			choices: [
				{
					disabled: false,
					desc: "Spørg Ayaan om timeløn",
					gotoId: "video11-1",
				},
				{
					disabled: false,
					desc: "Spørg Ayaan om hvor mange der arbejder på fabrikken",
					gotoId: "video11-2",
				},
			],
		},
		notifications: [],
	},
	// ============================================================================
	{
		id: "video11-1",
		name: "Spørg om timeløn",
		vimeoId: 472119618,
		inMenu: true,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video12-1",
			choices: [
				{
					disabled: false,
					desc: "Læs besked fra Valdemar",
					gotoId: "video12-1",
				},
				{
					disabled: false,
					desc: "Se Quicksnap fra Valdemar",
					gotoId: "video12-2",
				},
			],
		},
		notifications: [
			{
				timecode: 23,
				platform: "messages",
				duration: 4,
				from: "EVERYDAY UNIFORM",
				desc: "+50 nye varer online i denne uge! 🔥",
			},
		],
	},
	// =========================
	{
		id: "video11-2",
		name: "Spørg om antal medarbejdere",
		vimeoId: 472119619,
		inMenu: true,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video12-2",
			choices: [
				{
					disabled: false,
					desc: "Læs besked fra Valdemar",
					gotoId: "video12-1",
				},
				{
					disabled: false,
					desc: "Se Quicksnap fra Valdemar",
					gotoId: "video12-2",
				},
			],
		},
		notifications: [
			{
				timecode: 25,
				platform: "mail",
				duration: 4,
				from: "EVERYDAY UNIFORM",
				desc: "Det er nu eller aldrig! Grib chancen 🤜🤛",
			},
		],
	},
	// ============================================================================
	{
		id: "video12-1",
		name: "Læs tekstbesked",
		vimeoId: 472119675,
		inMenu: false,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video14-1",
			choices: [
				{
					disabled: false,
					desc: "Tag opslaget ned",
					gotoId: "video14-1",
				},
				{
					disabled: false,
					desc: "Behold opslaget oppe",
					gotoId: "video14-2",
				},
			],
		},
		notifications: [
			{
				timecode: 9,
				platform: "mail",
				duration: 4,
				from: "EVERYDAY UNIFORM",
				desc: "PSST... Du har glemt noget. Din indkøbskurv bliver ensom 🛒",
			},
		],
	},
	// =========================
	{
		id: "video12-2",
		name: "Se quicksnap",
		vimeoId: 472119679,
		inMenu: false,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video14-1",
			choices: [
				{
					disabled: false,
					desc: "Tag opslaget ned",
					gotoId: "video14-1",
				},
				{
					disabled: false,
					desc: "Behold opslaget oppe",
					gotoId: "video14-2",
				},
			],
		},
		notifications: [],
	},
	// ============================================================================
	{
		id: "video14-1",
		name: "Tag opslag ned",
		vimeoId: 472119706,
		inMenu: true,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video15-1",
			choices: [
				{
					disabled: false,
					desc: "Skriv til Ayaan og hør hvordan det går",
					gotoId: "video15-1",
				},
				{
					disabled: false,
					desc: "Fortæl Ayaan at du har slettet opslaget",
					gotoId: "video15-2",
				},
			],
		},
		notifications: [],
	},
	// =========================
	{
		id: "video14-2",
		name: "Behold opslag",
		vimeoId: 472311803,
		inMenu: true,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video15-4",
			choices: [
				{
					disabled: false,
					desc: "Slet opslaget",
					gotoId: "video15-3",
				},
				{
					disabled: false,
					desc: "Behold opslaget oppe",
					gotoId: "video15-4",
				},
			],
		},
		notifications: [],
	},
	// ============================================================================
	{
		id: "video15-1",
		name: "Skriv til Ayaan",
		vimeoId: 472311928,
		inMenu: true,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video16-1",
			choices: [
				{
					disabled: false,
					desc: "Ring til Fashion Truth og snak med Theresa",
					gotoId: "video16-1",
				},
				{
					disabled: false,
					desc: "Lad vær med at ringe til Fashion Truth",
					gotoId: "video16-2",
				},
			],
		},
		notifications: [],
	},
	// =========================
	{
		id: "video15-2",
		name: "Fortæl Ayaan at du har slettet opslaget",
		vimeoId: 477173960,
		inMenu: true,
		duration: NaN,
		lastVideo: true,
		choice: {
			active: false,
			duration: 0,
			defaultChoice: "video1-2",
			choices: [],
		},
		notifications: [
			{
				timecode: 19.835,
				from: "EVERYDAY UNIFORM",
				platform: "mail",
				desc: "Tillykke Mathias! Du er vores nye Brand Ambassadør! 🎉",
				duration: 5,
			},
		],
	},
	// =========================
	{
		id: "video15-3",
		name: "Slet opslaget",
		vimeoId: 477181830,
		inMenu: true,
		duration: NaN,
		lastVideo: true,
		choice: {
			active: false,
			duration: 0,
			defaultChoice: "video1-2",
			choices: [],
		},
		notifications: [
			{
				timecode: 19.835,
				from: "EVERYDAY UNIFORM",
				platform: "mail",
				desc: "Tillykke Mathias! Du er vores nye Brand Ambassadør! 🎉",
				duration: 5,
			},
		],
	},
	// =========================
	{
		id: "video15-4",
		name: "Snak med Ayaan og Theresa",
		vimeoId: 477181896,
		inMenu: true,
		duration: NaN,
		lastVideo: false,
		choice: {
			active: false,
			duration: 10,
			defaultChoice: "video16-3",
			choices: [
				{
					disabled: false,
					desc: "Se videoen om 'Arbejdsforhold'",
					gotoId: "video16-3",
				},
				{
					disabled: false,
					desc: "Se videoen om 'Fast Fashion'",
					gotoId: "video16-4",
				},
			],
		},
		notifications: [],
	},
	// ============================================================================
	{
		id: "video16-1",
		name: "Ring til Fashion Truth",
		vimeoId: 472324451,
		inMenu: true,
		duration: NaN,
		lastVideo: true,
		choice: {
			active: false,
			duration: 0,
			defaultChoice: "video1-2",
			choices: [],
		},
		notifications: [],
	},
	// =========================
	{
		id: "video16-2",
		name: "Ikke ring til Theresa",
		vimeoId: 477179912,
		inMenu: true,
		duration: NaN,
		lastVideo: true,
		choice: {
			active: false,
			duration: 0,
			defaultChoice: "video1-2",
			choices: [],
		},
		notifications: [],
	},
	{
		id: "video16-3",
		name: "'Arbejdsforhold' / Slutning",
		vimeoId: 477182820,
		inMenu: true,
		duration: NaN,
		lastVideo: true,
		choice: {
			active: false,
			duration: 0,
			defaultChoice: "video1-2",
			choices: [],
		},
		notifications: [],
	},
	// =========================
	{
		id: "video16-4",
		name: "'Fast Fashion' / Slutning",
		vimeoId: 477182853,
		inMenu: true,
		duration: NaN,
		lastVideo: true,
		choice: {
			active: false,
			duration: 0,
			defaultChoice: "video1-2",
			choices: [],
		},
		notifications: [],
	},
];

export default data;
